import { render, staticRenderFns } from "./BarnFences.vue?vue&type=template&id=2919a6c5&"
import script from "./BarnFences.vue?vue&type=script&lang=ts&"
export * from "./BarnFences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports